<template>
  <header class="sticky top-0 z-1 flex items-center bg-white p-2 between">
    <base-link :aria-label="$t.back" class="group" :to="backRoute">
      <span class="m-1 block rounded-xs p-1 duration group-hover:bg-brand-2">
        <vf-icon dir="left" name="chevron" size="lg" />
      </span>
    </base-link>
    <base-link :to="homeLink">
      <base-picture
        :alt="$t.customs.title"
        height="28"
        src="https://assets.vans.com/image/upload/v1730381153/customs.svg"
        width="95"
      />
    </base-link>
    <base-button class="group" @click="DialogMiniCart.open">
      <span class="relative m-1 block rounded-xs p-1 duration group-hover:bg-brand-2">
        <span class="sr-only">
          {{ replaceAll($pluralize($t.cartIconLabel, cart?.totalItems), { count: cart.totalItems }) }}
        </span>
        <vf-icon name="bag" :size="{ sm: 'md', lg: 'lg' }" />
        <client-only>
          <span
            v-if="cart?.totalItems"
            aria-hidden="true"
            class="absolute right-0 top-0 m-1 h-3 w-3 flex select-none center rounded-full bg-brand-3 text-micro c-white ring ring-white lg:h-4 lg:w-4 lg:text-xs"
            style="line-height: 1"
          >
            {{ cart.totalItems }}
          </span>
        </client-only>
      </span>
    </base-button>
  </header>
</template>

<script lang="ts" setup>
defineProps<{
  backRoute: string
}>()

const { homeLink } = useAppConfig().components.customs.header
const cart = useCartStore()
const { DialogMiniCart } = useDialogsStore()
</script>
